import { useEffect, useState } from 'react'
import { REPORTS_API } from '../../../constants'
import { useAuth0 } from '@auth0/auth0-react'

interface IData {
  boardPersons: number
  date: string
  manual: number
  marketplaceListings: number
  messageSendingPersons: number
  privateInstallables: number
  total: number
}

export const useGetDayMessageSources = (searchKey: string | null) => {
  const { getAccessTokenSilently } = useAuth0()
  const [data, setData] = useState<IData | null>(null)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${REPORTS_API}/message-sent/day/${searchKey}`, {
          headers: { 'X-Vestaboard-Token': await getAccessTokenSilently() }
        })
        const json = await response.json()

        setData(json)
      } catch (e) {
        setData(null)
      }
    }

    if (!!searchKey) {
      fetchData()
    }
  }, [searchKey, getAccessTokenSilently])

  return { data }
}
